/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { Grid, Paper, Button } from "@mui/material";
import MyTable, { TableRow } from "../../../components/MyTable";
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import MySnackbar from "../../../components/MySnackbar";
import DownloadIcon from "@mui/icons-material/Download";
import { DownloadResponse, getPaymentSlipsDownloadMonitor, PaymentSlipDownload, paymentSlipsBulkDownload } from "../../../api/s10DocumentsApi";

const AdminPaymentSlipDownloads = () => {
    const [data, setData] = useState<PaymentSlipDownload[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);

    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const fetchDownloads = async () => {
        setLoading(true);
        try {
            const result = await getPaymentSlipsDownloadMonitor();
            console.log('getPaymentSlipsDownloadMonitor', result);
            setData(result || []);
            setTotalItems(result?.length || 0);
        } catch (error: any) {
            setErrorMsg(error.message || "Error al cargar los datos");
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = async (id: number) => {
        try {
            const result: DownloadResponse = await paymentSlipsBulkDownload(id);
            if (result.Type !== 0) {
                throw new Error(result.Message || "Error al obtener la URL de descarga");
            }
            const { Presigned_URL } = result.Value;
            window.open(Presigned_URL, "_blank");
        } catch (error: any) {
            setErrorMsg(error.message || "Error al descargar el archivo");
        }
    };

    const DownloadButton = (headRow: TableHeadRows, row: TableRow<string, any>) => {
        if (row.Status !== "Completado") {
            return <></>;
        }
        return (
            <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<DownloadIcon />}
                onClick={() => handleDownload(row.Id)}
            >
                Descargar
            </Button>
        );
    };

    const tableHeadRows: TableHeadRows[] = [
        {
            label: "RUC",
            rowKeyName: "RUC",
            allowOrderAction: true,
        },
        {
            label: "Nombre RUC",
            rowKeyName: "RUCName",
            allowOrderAction: true,
        },
        {
            label: "Esquema",
            rowKeyName: "SchemePayrollName",
            allowOrderAction: true,
        },
        {
            label: "Fecha Inicio",
            rowKeyName: "DateStart",
            allowOrderAction: true,
        },
        {
            label: "Fecha Fin",
            rowKeyName: "DateEnd",
            allowOrderAction: true,
        },
        {
            label: "Usuario",
            rowKeyName: "CreationUser",
            allowOrderAction: true,
        },
        {
            label: "Estado",
            rowKeyName: "Status",
            allowOrderAction: true,
        },
        {
            label: "Fecha Creación",
            rowKeyName: "CreationDate",
            allowOrderAction: true,
        },
        {
            label: "Acción",
            rowKeyName: "action",
            customValue: DownloadButton,
        },
    ];

    useEffect(() => {
        fetchDownloads();

        intervalRef.current = setInterval(() => {
            fetchDownloads();
        }, 60000); // 1 minut

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, []);

    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
            <Paper
                elevation={3}
                style={{
                    width: "100%",
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "2rem 1.5rem",
                }}
            >
                <MyTable
                    key="tab-downloads"
                    pageNumber={page}
                    itemsPerPage={pageSize}
                    totalItems={totalItems}
                    totalPages={Math.ceil(totalItems / pageSize)}
                    onChangePageNumber={setPage}
                    onChangeItemsPerPage={setPageSize}
                    hiddenSearchInput={true}
                    tableHeadRows={tableHeadRows}
                    tableRows={data}
                    loading={loading}
                    tableOptionsBar={{
                        useDrawer: false,
                    }}
                    hiddenFilterOptions={true}
                />
            </Paper>

            {errorMsg && (
                <MySnackbar
                    msg={errorMsg}
                    severity="error"
                    open={!!errorMsg}
                    onClose={() => setErrorMsg("")}
                />
            )}
        </Grid>
    );
};

export default AdminPaymentSlipDownloads;